<template>
    <common-page-loader :isLoading="isLoading">
        <div>
            <header class="simple-layout__header">
                <div v-if="$auth.isSubdomainActive()" class="simple-layout__header--subdomain">
                    <common-company-avatar
                        :withBorder="true"
                        :company="getSubdomainCompany"
                        :size="isSmall ? 'micro' : 'small'"
                    ></common-company-avatar>
                    <p>{{ getSubdomainCompany.name }}</p>
                </div>
                <router-link v-else :to="{ name: RoutesEnum.INDEX.HOME }" class="simple-layout__logo">
                    <common-icon name="logo" size="extra-large"></common-icon>
                </router-link>

                <locale-select></locale-select>
            </header>

            <slot></slot>
        </div>
    </common-page-loader>
</template>

<script>
    import Store from '@/store'
    import RoutesEnum from 'enums/routes.enum'
    import LocaleSelect from 'components/page-elements/localization/LocaleSelect'
    import VersionUpdateServiceWorkerMixin from 'mixins/VersionUpdateServiceWorkerMixin'

    export default {
        mixins: [VersionUpdateServiceWorkerMixin],
        components: { LocaleSelect },

        data: () => ({ RoutesEnum }),

        computed: {
            isLoading() {
                return Store.getters['configuration/getIsLoading']
            },

            getSubdomainCompany() {
                return Store.getters['data/getSubdomainCompany']
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    .simple-layout {
        &__header {
            height: 120px;
            text-align: left;
            padding: 20px;
            align-items: center;
            justify-content: space-between;
            display: flex;

            &--subdomain {
                display: flex;
                align-items: center;

                p {
                    margin-left: 20px;
                    text-align: center;
                    font-size: $font-size--heading-small;
                    color: $color--accent-1;
                }
            }
        }

        &__logo {
            svg {
                height: 100px;
                width: 100px;
            }
        }
    }
</style>
